/* ═══════════════════════════════════════════════════════════════════
   MATRIKAR — Vehicle Fit Selector JS (externalized P6 — 2026-05-22)
   Source : snippets/matrikar-vehicle-fit.liquid (formerly inline)
   Loaded : defer, only on PDPs (via Liquid conditional in snippet)
   Reads bootstrap inline global :
     window.MK_VFIT_SHOW_STEERING — boolean from {% assign show_steering %}
   Reads pre-existing async globals :
     window.MATRIKAR_DB, window.MATRIKAR_FUEL, window.MATRIKAR_GEN_YEAR,
     window.MATRIKAR_EXPAND_YEARS (all loaded via matrikar-data.js +
     matrikar-shared.js, both defer in layout/theme.liquid)
   ═══════════════════════════════════════════════════════════════════ */

(function () {
  var T = window.MK_I18N || {}; // i18n display strings (bridge from matrikar-vehicle-fit.liquid)
  var DB = null;
  var sel = { make: '', model: '', year: '', sub: '', seats: '', drive: '', fuel: '' };
  // Fuel labels must be the i18n (FR/EN) strings, NOT the raw English from window.MATRIKAR_FUEL.
  var FUEL = { P: T.fuel_petrol_diesel, E: T.fuel_electric, PH: T.fuel_plugin_hybrid, FH: T.fuel_full_hybrid, MH: T.fuel_mild_hybrid, FC: T.fuel_fuel_cell };
  var isLoading = true;
  var btnObserver = null;

  function g(id) { return document.getElementById(id); }
  function uniq(arr) { return [...new Set(arr)].sort(); }
  function esc(s) { return (s || '').replace(/'/g, "\\'"); }

  function getProductForm() {
    // Locale-independent : en FR le form a action="/fr/cart/add" (route localisée), donc
    // action="/cart/add" EXACT ne matche pas → il faut action*="/cart/add". Et on scope
    // TOUJOURS sur form[...] : sinon [id^="product-form-"] matchait un <input> radio d'option
    // (id "product-form-main-…-option2-1") au lieu du <form> → gate + injection cassés en FR.
    var sels = [
      'form[action*="/cart/add"][id^="product-form-main"]:not([id*="payment-installment"]):not([id*="installment"])',
      'form[action*="/cart/add"]:not([id*="payment-installment"]):not([id*="installment"])'
    ];
    for (var i = 0; i < sels.length; i++) {
      var f = document.querySelector(sels[i]);
      if (f) return f;
    }
    var buyButtons = document.querySelector('buy-buttons');
    if (buyButtons) {
      var cf = buyButtons.closest('form');
      if (cf) return cf;
    }
    return document.querySelector('form.product-form') || null;
  }

  function isVehicleConfirmed() {
    var saved = null;
    try { saved = JSON.parse(localStorage.getItem('matrikar_vehicle') || 'null'); } catch(e) {}
    return !!(saved && saved.make && saved.year && saved.model);
  }

  // ─── Core button lock (no loop) ──────────────────────────────────────────
  function forceButtonState() {
    var confirmed = isVehicleConfirmed();
    var form = getProductForm();
    if (!form) return;

    var submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) {
      if (!confirmed) {
        if (submitBtn.disabled !== true) {
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-disabled', 'true');
          submitBtn.style.opacity = '0.5';
          submitBtn.style.cursor = 'not-allowed';
          submitBtn.title = T.confirm_vehicle_first;
        }
      } else {
        if (submitBtn.disabled === true) {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-disabled');
          submitBtn.style.opacity = '';
          submitBtn.style.cursor = '';
          submitBtn.title = '';
        }
      }
    }

    // Express (Shop Pay / Buy it now) : le bouton réel est souvent dans un IFRAME →
    // form.querySelector('.shopify-payment-button button') renvoie null (vérifié en runtime).
    // On bloque donc le CONTENEUR .shopify-payment-button (pointer-events + opacity), qui EST
    // dans le form et accessible ; + on désactive le <button> natif s'il est présent.
    var payWrap = form.querySelector('.shopify-payment-button');
    if (payWrap) {
      if (!confirmed) {
        payWrap.style.pointerEvents = 'none';
        payWrap.style.opacity = '0.5';
        payWrap.setAttribute('aria-disabled', 'true');
      } else {
        payWrap.style.pointerEvents = '';
        payWrap.style.opacity = '';
        payWrap.removeAttribute('aria-disabled');
      }
      var payBtn = payWrap.querySelector('button');
      if (payBtn) payBtn.disabled = !confirmed;
    }

    // MK GARDE SERVEUR : le verrou express initial vient du serveur via la CLASSE
    // .mk-express-locked (buy-buttons.liquid). Les styles inline ci-dessus ne peuvent PAS
    // annuler une regle CSS -> sans ce toggle, l'express resterait bloque meme vehicule
    // confirme. On pilote donc la classe ici aussi.
    var expGrid = form.querySelector('.express-payments-grid');
    if (expGrid) expGrid.classList.toggle('mk-express-locked', !confirmed);

    var msg = document.getElementById('mkvfit-required-message');
    if (!confirmed) {
      if (!msg) {
        msg = document.createElement('div');
        msg.id = 'mkvfit-required-message';
        msg.className = 'mkvfit-required-message';
        msg.textContent = T.required_before_cart;
        if (submitBtn && submitBtn.parentNode) {
          submitBtn.parentNode.insertBefore(msg, submitBtn.nextSibling);
        }
      }
    } else {
      if (msg) msg.remove();
    }
  }

  var reapplyTimer = null;
  function reapplyButtonState() {
    clearTimeout(reapplyTimer);
    reapplyTimer = setTimeout(forceButtonState, 60);
  }

  // ─── MutationObserver (now safe) ─────────────────────────────────────────
  function attachButtonObserver() {
    if (btnObserver) { btnObserver.disconnect(); btnObserver = null; }
    var form = getProductForm();
    if (!form) return;
    var submitBtn = form.querySelector('button[type="submit"]');
    if (!submitBtn) return;

    btnObserver = new MutationObserver(function(mutations) {
      if (isVehicleConfirmed()) return;
      if (submitBtn.disabled === true) return;
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-disabled', 'true');
      submitBtn.style.opacity = '0.5';
      submitBtn.style.cursor = 'not-allowed';
    });

    btnObserver.observe(submitBtn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'style'] });
  }

  function onVehicleChange() {
    forceButtonState();
  }

  // ─── Cart properties ─────────────────────────────────────────────────────
  // FILL-ONLY (2026-07-16) — les 6 inputs sont desormais rendus par le SERVEUR
  // (snippets/buy-buttons.liquid), vides et `disabled`, des le 1er octet. Ce JS ne les CREE
  // plus et ne les DETRUIT plus : il remplit la value et bascule `disabled`.
  // Pourquoi : les creer en JS laissait une fenetre (~280 ms) ou le form n'avait aucune
  // propriete, et surtout les creait VIDES -> properties[Vehicle]="" partait. Un input
  // `disabled` n'est pas serialise par FormData (verifie en reel sur /cart/add).
  // Ne cree un input QUE s'il manque vraiment (produit custom-fit dont le form serait rendu
  // sans les inputs statiques) : filet de securite, jamais le cas nominal.
  function ensureCartProperties() {
    var form = getProductForm();
    if (!form) return;
    [
      { key: 'vehicle', name: 'Vehicle' },
      { key: 'year',    name: 'Vehicle Year' },
      { key: 'trim',    name: 'Trim' },
      { key: 'seats',   name: 'Seats' },
      { key: 'drive',   name: 'Drive Side' },
      { key: 'fuel',    name: 'Fuel Type' }
    ].forEach(function(prop) {
      if (form.querySelector('[data-mkvfit="' + prop.key + '"]')) return; // deja rendu serveur
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + prop.name + ']';
      input.setAttribute('data-mkvfit', prop.key);
      input.disabled = true; // vide => non serialise
      form.appendChild(input);
    });
  }

  function updateCartProperties(data) {
    var form = getProductForm();
    if (!form) return;
    var vehicleStr = (data.make || '') + ' ' + (data.model || '') + (data.sub ? ' ' + data.sub : '');
    var map = { vehicle: vehicleStr, year: data.year || '', trim: data.sub || '', seats: data.seats ? data.seats + ' ' + (T.seats_suffix || 'seats') : '', drive: data.drive || '', fuel: data.fuel || '' };
    Object.keys(map).forEach(function(key) {
      var el = form.querySelector('[data-mkvfit="' + key + '"]');
      if (!el) return;
      el.value = map[key];
      // Une valeur vide reste `disabled` => jamais de properties[X]="" au panier.
      el.disabled = !map[key];
    });
  }

  function clearCartProperties() {
    var form = getProductForm();
    if (!form) return;
    ['vehicle','year','trim','seats','drive','fuel'].forEach(function(key) {
      var el = form.querySelector('[data-mkvfit="' + key + '"]');
      if (!el) return;
      el.value = '';
      el.disabled = true; // reset => on re-neutralise l'input
    });
  }

  function formatVehicleDetails(data) {
    var parts = [];
    if (data.seats) parts.push(data.seats + ' ' + (T.seats_suffix || 'seats'));
    if (data.drive) parts.push(data.drive);
    if (data.fuel)  parts.push(data.fuel);
    return parts.join(' · ');
  }

  // ─── Saved vehicle ───────────────────────────────────────────────────────
  function loadSavedVehicle() {
    var saved = null;
    try { saved = JSON.parse(localStorage.getItem('matrikar_vehicle') || 'null'); } catch(e) {}

    // HOTFIX_HIDE_STEERING : normaliser RHD → LHD pour visiteurs résiduels
    if (saved && saved.drive === 'RHD') {
      saved.drive = 'LHD';
      try { localStorage.setItem('matrikar_vehicle', JSON.stringify(saved)); } catch (e) {}
    }

    if (saved && saved.make && saved.year && saved.model) {
      sel = saved;
      /* recompute _genYears so downstream pSub/pickDrive (after "Edit") can map sel.year to gen */
      if (DB) {
        sel._genYears = uniq(DB.filter(function(r) { return r.make === sel.make && r.model === sel.model; }).map(function(r) { return r.year; }));
      }
      updateCartProperties(sel);
      var displayName = saved.make + ' ' + saved.model + (saved.sub ? ' ' + saved.sub : '') + ' (' + saved.year + ')';
      var vehicleEl = g('mkvfit-vehicle-name');
      var detailsEl = g('mkvfit-vehicle-details');
      if (vehicleEl) vehicleEl.textContent = displayName;
      if (detailsEl) detailsEl.textContent = formatVehicleDetails(saved);
      g('mkvfit-saved').style.display = 'flex';
      g('mkvfit-selector').style.display = 'none';
      onVehicleChange();
      return true;
    } else {
      g('mkvfit-saved').style.display = 'none';
      g('mkvfit-selector').style.display = 'block';
      onVehicleChange();
      return false;
    }
  }

  function resetToEmpty() {
    localStorage.removeItem('matrikar_vehicle');
    sel = { make: '', model: '', year: '', sub: '', seats: '', drive: '', fuel: '' };
    clearCartProperties();
    g('mkvfit-saved').style.display = 'none';
    g('mkvfit-selector').style.display = 'block';
    resetSelectorUI();
    onVehicleChange();
    // Notifier les listeners EXTERNES (sticky nav mkv4, sections seat, …) que le véhicule a été
    // vidé. Ils ne se re-synchronisent que sur 'storage' (matrikar_vehicle) ou 'matrikar:vehicleSelected' ;
    // sans ça le sticky "Ajouter au panier" restait ACTIF après un reset/changement (bug FR & EN).
    // storage same-tab ne se déclenche pas nativement → on le simule ; language-independent.
    try { window.dispatchEvent(new StorageEvent('storage', { key: 'matrikar_vehicle', newValue: null, oldValue: 'x' })); } catch (e) {}
    if (DB) initMakes(); else waitForDB(initMakes);
  }

  function resetSelectorUI() {
    g('mkvfit-lbl-make').textContent = T.car_make;
    g('mkvfit-lbl-model').textContent = T.model;
    g('mkvfit-btn-make').classList.remove('filled');
    g('mkvfit-btn-model').classList.remove('filled');
    g('mkvfit-btn-make').classList.remove('mkvfit-next');
    g('mkvfit-btn-model').classList.remove('mkvfit-next');
    g('mkvfit-btn-model').classList.add('mkvfit-dropbtn--disabled');

    // Reset model dot to grey (make garde son point rouge)
    var modelBtn = g('mkvfit-btn-model');
    if (modelBtn) {
      var modelDot = modelBtn.querySelector('.mkvfit-dot');
      if (modelDot) { modelDot.classList.remove('mkvfit-dot'); modelDot.classList.add('mkvfit-dot--grey'); }
    }

    var py = g('mkvfit-pills-year'); if (py) py.innerHTML = '';
    ['year','trim','seats','drive','engine'].forEach(function(s) {
      openStepPicker(s);
      var el = g('mkvfit-step-' + s);
      if (el) el.style.display = 'none';
    });
    var cw = g('mkvfit-confirm-wrap');
    if (cw) cw.style.display = 'none';
    document.querySelectorAll('.mkvfit-pill.active').forEach(function(p) { p.classList.remove('active'); });
  }

  // ─── DB ───────────────────────────────────────────────────────────────────
  // 7s timeout (70 × 100ms). Globals (FUEL/LOGOS) upgraded inside buildDB once matrikar-shared.js has run.
  function waitForDB(cb) {
    var attempts = 0;
    var check = function() {
      attempts++;
      if (typeof window.MATRIKAR_DB !== 'undefined' && window.MATRIKAR_DB !== null) {
        buildDB(); if (cb) cb(); isLoading = false; return;
      }
      if (attempts >= 70) {
        isLoading = false;
        var el = g('mkvfit-list-make');
        if (el) el.innerHTML = '<div class="mkvfit-dropitem" style="color:var(--mk-grey, #5E5E70);">' + T.data_unavailable + '</div>';
        return;
      }
      setTimeout(check, 100);
    };
    check();
  }

  function buildDB() {
    if (DB) return;
    // Keep i18n fuel labels (do NOT overwrite with raw English window.MATRIKAR_FUEL); re-read T in case the bridge populated after init.
    FUEL = { P: T.fuel_petrol_diesel, E: T.fuel_electric, PH: T.fuel_plugin_hybrid, FH: T.fuel_full_hybrid, MH: T.fuel_mild_hybrid, FC: T.fuel_fuel_cell };
    var raw = window.MATRIKAR_DB;
    if (!raw || !raw.data) return;
    DB = raw.data.map(function(r) {
      return {
        make:  raw.makes ? raw.makes[r[0]] : r[0],
        model: r[1], sub: r[2], year: String(r[3]),
        seats: r[4],
        fuel:  FUEL[r[5]] || r[5] || T.fuel_petrol_diesel
      };
    });
  }

  // ─── Bottom sheet (mobile ≤699px) + collapse helpers ──────────────────────
  var MQ_MOBILE = '(max-width: 699px)';
  function isMobile() { return !!(window.matchMedia && window.matchMedia(MQ_MOBILE).matches); }

  var scrollLockY = null;
  function lockBody() {
    if (scrollLockY !== null) return;
    scrollLockY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = (-scrollLockY) + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
  function unlockBody() {
    if (scrollLockY === null) return;
    var y = scrollLockY; scrollLockY = null;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, y);
  }

  function openSheetPanel() {
    var d = document.querySelector('#mkvfit-wrap .mkvfit-drop.open');
    return d ? d.querySelector('.mkvfit-droppanel') : null;
  }
  function syncSheetToViewport() {
    if (!isMobile()) return;
    var pan = openSheetPanel(), vv = window.visualViewport;
    if (!pan || !vv) return;
    var gap = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
    if (gap > 0) { pan.style.bottom = gap + 'px'; pan.style.maxHeight = Math.max(160, Math.round(vv.height - 16)) + 'px'; }
    else { pan.style.bottom = ''; pan.style.maxHeight = ''; }
  }
  function clearSheetInline() {
    ['make','model'].forEach(function(k) { var p = g('mkvfit-panel-' + k); if (p) { p.style.bottom = ''; p.style.maxHeight = ''; } });
  }
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', syncSheetToViewport);
    window.visualViewport.addEventListener('scroll', syncSheetToViewport);
  }
  function addSheetBackdrop() {
    if (!isMobile() || g('mkvfit-sheetbd')) return;
    lockBody();
    var w = g('mkvfit-wrap'); if (w) w.classList.add('mkvfit-sheet-lift');
    var bd = document.createElement('div');
    bd.className = 'mkvfit-sheet-backdrop';
    bd.id = 'mkvfit-sheetbd';
    bd.addEventListener('click', function() { closeDrops(); });
    // Fix empilement PDP : le backdrop est attaché DANS #mkvfit-wrap (même contexte d'empilement
    // que le panneau) — sinon un ancêtre positionné de la page produit piège le panneau SOUS un
    // backdrop resté enfant de body, qui intercepte les taps. Ici backdrop(9998) < panneau(9999)
    // dans le même contexte → panneau au-dessus, liste cliquable.
    (w || document.body).appendChild(bd);
    syncSheetToViewport();
  }
  function removeSheetBackdrop() {
    var bd = g('mkvfit-sheetbd'); if (bd && bd.parentNode) bd.parentNode.removeChild(bd);
    var w = g('mkvfit-wrap'); if (w) w.classList.remove('mkvfit-sheet-lift');
    clearSheetInline(); unlockBody();
  }

  /* Surligner l'étape suivante (au lieu de l'ouvrir automatiquement) */
  function highlightNext(key) {
    ['make','model'].forEach(function(k) { var b = g('mkvfit-btn-' + k); if (b) b.classList.remove('mkvfit-next'); });
    var b = g('mkvfit-btn-' + key); if (b) b.classList.add('mkvfit-next');
  }

  /* Replier / rouvrir une étape (year/trim/seats/engine) en champ compact "valeur ▾" */
  function collapseStep(step, txt) {
    var l = g('mkvfit-lblc-' + step), p = g('mkvfit-picker-' + step), c = g('mkvfit-chosen-' + step);
    if (l) l.textContent = txt;
    if (p) p.style.display = 'none';
    if (c) c.style.display = 'block';
  }
  function openStepPicker(step) {
    var p = g('mkvfit-picker-' + step), c = g('mkvfit-chosen-' + step);
    if (c) c.style.display = 'none';
    if (p) p.style.display = '';
  }

  // ─── Dropdowns ────────────────────────────────────────────────────────────
  function closeDrops() {
    ['make','model'].forEach(function(k) {
      var el = g('mkvfit-drop-' + k);
      if (el) el.classList.remove('open');
    });
    removeSheetBackdrop();
  }

  function togDrop(key) {
    var el = g('mkvfit-drop-' + key);
    var btn = g('mkvfit-btn-' + key);
    if (!el || btn.classList.contains('mkvfit-dropbtn--disabled')) return;
    var wasOpen = el.classList.contains('open');
    closeDrops();
    if (!wasOpen) {
      el.classList.add('open');
      var src = g('mkvfit-search-' + key);
      // HOTFIX_DROPDOWN_UX : pas de focus auto → clavier mobile reste fermé jusqu'au tap manuel
      if (src) { src.value = ''; filterList(key); }
      if (isMobile()) {
        addSheetBackdrop();
      } else {
        requestAnimationFrame(function() {
          var pan = g('mkvfit-panel-' + key);
          if (pan) { var r = pan.getBoundingClientRect(); if (r.bottom > (window.innerHeight || 0)) pan.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
        });
      }
    }
  }

  function filterList(key) {
    var src = g('mkvfit-search-' + key);
    if (!src) return;
    var q = src.value.toLowerCase();
    var list = g('mkvfit-list-' + key);
    if (!list) return;
    list.querySelectorAll('.mkvfit-dropitem').forEach(function(el) {
      el.style.display = el.dataset.v.toLowerCase().indexOf(q) > -1 ? '' : 'none';
    });
  }

  function buildList(listId, items, fn, activeVal) {
    var el = g(listId);
    if (!el) return;
    if (!items || !items.length) {
      el.innerHTML = '<div class="mkvfit-dropitem" style="color:var(--mk-grey, #5E5E70);">' + T.no_options + '</div>'; return;
    }
    el.innerHTML = items.map(function(v) {
      return '<button type="button" class="mkvfit-dropitem' + (v === activeVal ? ' active' : '') + '" data-v="' + v + '" onclick="MKVFIT.' + fn + '(\'' + esc(v) + '\')">' + v + '</button>';
    }).join('');
  }

  function initMakes() {
    if (!DB) return;
    buildList('mkvfit-list-make', uniq(DB.map(function(r) { return r.make; })), 'pMake', sel.make);
    g('mkvfit-btn-make').classList.remove('mkvfit-dropbtn--disabled');
  }

  function enableDrop(key) {
    var btn = g('mkvfit-btn-' + key);
    if (btn) {
      btn.classList.remove('mkvfit-dropbtn--disabled');
      // Change dot from grey to red
      var dot = btn.querySelector('.mkvfit-dot');
      if (dot && dot.classList.contains('mkvfit-dot--grey')) {
        dot.classList.remove('mkvfit-dot--grey');
        dot.classList.add('mkvfit-dot');
      }
    }
  }

  function clearStepsFrom(from) {
    var order = ['trim','seats','drive','engine'];
    for (var i = order.indexOf(from); i < order.length; i++) {
      var el = g('mkvfit-step-' + order[i]);
      if (el) el.style.display = 'none';
    }
    g('mkvfit-confirm-wrap').style.display = 'none';
  }

  // P8 AUTO-CONFIRM : press animation (300ms total) + trigger MKVFIT.confirm()
  // Triggered from pFuel when all fields are auto-resolved (or mix auto + user choice).
  // Animation press : scale(0.95) hold 150ms then scale(1.0) 150ms ease.
  // Then call MKVFIT.confirm() which displays "Perfect Fit Confirmed" + CustomEvent.
  function tryAutoConfirm() {
    if (!sel.make || !sel.model || !sel.year || !sel.sub || !sel.seats || !sel.drive || !sel.fuel) return;
    setTimeout(function() {
      var confirmBtn = g('mkvfit-confirm-btn');
      if (!confirmBtn || confirmBtn.getBoundingClientRect().height === 0) {
        // Fallback if button not yet rendered : just confirm directly
        window.MKVFIT.confirm();
        return;
      }
      confirmBtn.style.transition = 'transform 0.225s cubic-bezier(0.4, 0.0, 0.2, 1), box-shadow 0.225s cubic-bezier(0.4, 0.0, 0.2, 1)';
      confirmBtn.style.transform = 'scale(0.95)';
      confirmBtn.style.boxShadow = 'inset 0 1px 2px rgba(0,0,0,0.12)';
      setTimeout(function() {
        confirmBtn.style.transform = 'scale(1.0)';
        confirmBtn.style.boxShadow = '';
        setTimeout(function() {
          confirmBtn.style.transition = '';
          window.MKVFIT.confirm();
        }, 225);
      }, 225);
    }, 150);
  }

  // ─── Public API ───────────────────────────────────────────────────────────
  window.MKVFIT = {
    pMake: function(m) {
      sel = { make: m, model: '', year: '', sub: '', seats: '', drive: '', fuel: '' };
      closeDrops();
      g('mkvfit-btn-make').classList.remove('mkvfit-next');
      g('mkvfit-lbl-make').textContent = m; g('mkvfit-btn-make').classList.add('filled');
      g('mkvfit-lbl-model').textContent = T.model; g('mkvfit-btn-model').classList.remove('filled');
      var pyM = g('mkvfit-pills-year'); if (pyM) pyM.innerHTML = '';
      g('mkvfit-step-year').style.display = 'none';
      clearStepsFrom('trim'); onVehicleChange();
      if (!DB) return;
      buildList('mkvfit-list-model', uniq(DB.filter(function(r) { return r.make === m; }).map(function(r) { return r.model; })), 'pModel', '');
      enableDrop('model'); highlightNext('model');
    },

    pModel: function(m) {
      sel.model = m; closeDrops();
      g('mkvfit-btn-model').classList.remove('mkvfit-next');
      g('mkvfit-lbl-model').textContent = m; g('mkvfit-btn-model').classList.add('filled');
      clearStepsFrom('trim'); onVehicleChange();
      if (!DB) return;
      var genYrs = uniq(DB.filter(function(r) { return r.make === sel.make && r.model === m; }).map(function(r) { return r.year; }));
      sel._genYears = genYrs;
      var yrs = window.MATRIKAR_EXPAND_YEARS ? window.MATRIKAR_EXPAND_YEARS(genYrs) : genYrs.slice().reverse();
      g('mkvfit-pills-year').innerHTML = yrs.map(function(y) {
        return '<button type="button" class="mkvfit-pill" onclick="MKVFIT.pYear(\'' + esc(y) + '\')">' + y + '</button>';
      }).join('');
      openStepPicker('year');
      g('mkvfit-step-year').style.display = 'flex';
    },

    pYear: function(y) {
      sel.year = y;
      g('mkvfit-pills-year').querySelectorAll('.mkvfit-pill').forEach(function(p) { p.classList.toggle('active', p.textContent === y); });
      collapseStep('year', y);
      clearStepsFrom('trim'); onVehicleChange();
      if (!DB) return;
      var genY = window.MATRIKAR_GEN_YEAR ? window.MATRIKAR_GEN_YEAR(sel._genYears || [y], y) : y;
      var subs = uniq(DB.filter(function(r) { return r.make === sel.make && r.model === sel.model && r.year === genY; }).map(function(r) { return r.sub; }));
      // P8 AUTO-SELECT : if 1 sub, skip step display + auto-call pSub
      if (subs.length === 1) {
        setTimeout(function() { window.MKVFIT.pSub(subs[0]); }, 250);
        return;
      }
      // Fallback DB hole : if 0 subs, default to '-' to unlock downstream
      if (subs.length === 0) {
        setTimeout(function() { window.MKVFIT.pSub('-'); }, 250);
        return;
      }
      g('mkvfit-pills-trim').innerHTML = subs.map(function(s) {
        return '<button type="button" class="mkvfit-pill" onclick="MKVFIT.pSub(\'' + esc(s) + '\')">' + s + '</button>';
      }).join('');
      openStepPicker('trim');
      g('mkvfit-step-trim').style.display = 'flex';
    },

    pSub: function(s) {
      sel.sub = s;
      g('mkvfit-pills-trim').querySelectorAll('.mkvfit-pill').forEach(function(p) { p.classList.toggle('active', p.textContent === s); });
      if (g('mkvfit-step-trim').style.display !== 'none') collapseStep('trim', s);
      clearStepsFrom('seats'); onVehicleChange();
      if (!DB) return;
      var genY = window.MATRIKAR_GEN_YEAR ? window.MATRIKAR_GEN_YEAR(sel._genYears || [sel.year], sel.year) : sel.year;
      var seats = uniq(DB.filter(function(r) {
        return r.make === sel.make && r.model === sel.model && r.year === genY && r.sub === s;
      }).map(function(r) { return String(r.seats); })).sort(function(a,b) { return +a - +b; });
      // P8 AUTO-SELECT : if 1 seats, skip step display + auto-call pSeats
      if (seats.length === 1) {
        setTimeout(function() { window.MKVFIT.pSeats(seats[0]); }, 250);
        return;
      }
      // Fallback DB hole : if 0 seats, default to '5' (most common)
      if (seats.length === 0) {
        setTimeout(function() { window.MKVFIT.pSeats('5'); }, 250);
        return;
      }
      g('mkvfit-pills-seats').innerHTML = seats.map(function(n) {
        return '<button type="button" class="mkvfit-pill" onclick="MKVFIT.pSeats(\'' + n + '\')">' + n + ' ' + (T.seats_suffix || 'seats') + '</button>';
      }).join('');
      openStepPicker('seats');
      g('mkvfit-step-seats').style.display = 'flex';
    },

    pSeats: function(s) {
      sel.seats = s;
      g('mkvfit-pills-seats').querySelectorAll('.mkvfit-pill').forEach(function(p) { p.classList.toggle('active', p.textContent === s + ' ' + (T.seats_suffix || 'seats')); });
      if (g('mkvfit-step-seats').style.display !== 'none') collapseStep('seats', s + ' ' + (T.seats_suffix || 'seats'));
      clearStepsFrom('drive'); onVehicleChange();
      // P6 EXTRACT : read steering mode from window global (bootstrap inline)
      if (window.MK_VFIT_SHOW_STEERING) {
        var lhd = g('mkvfit-lhd'), rhd = g('mkvfit-rhd');
        if (lhd) { lhd.onclick = function() { MKVFIT.pickDrive('LHD'); }; lhd.classList.remove('active'); }
        if (rhd) { rhd.onclick = function() { MKVFIT.pickDrive('RHD'); }; rhd.classList.remove('active'); }
        g('mkvfit-step-drive').style.display = 'flex';
      } else {
        // HOTFIX_HIDE_STEERING : auto-set LHD (Canada+USA only)
        MKVFIT.pickDrive('LHD');
      }
    },

    pickDrive: function(d) {
      sel.drive = d;
      var lhd = g('mkvfit-lhd'), rhd = g('mkvfit-rhd');
      if (lhd) lhd.classList.toggle('active', d === 'LHD');
      if (rhd) rhd.classList.toggle('active', d === 'RHD');
      clearStepsFrom('engine'); onVehicleChange();
      if (!DB) return;
      var genY = window.MATRIKAR_GEN_YEAR ? window.MATRIKAR_GEN_YEAR(sel._genYears || [sel.year], sel.year) : sel.year;
      var fuels = uniq(DB.filter(function(r) {
        return r.make === sel.make && r.model === sel.model && r.year === genY && r.sub === sel.sub && String(r.seats) === sel.seats;
      }).map(function(r) { return r.fuel; }));
      if (!fuels.length) fuels = [T.fuel_petrol_diesel];
      // P8 AUTO-SELECT : if 1 fuel, skip step display + auto-call pFuel
      if (fuels.length === 1) {
        setTimeout(function() { window.MKVFIT.pFuel(fuels[0]); }, 250);
        return;
      }
      g('mkvfit-pills-engine').innerHTML = fuels.map(function(f) {
        return '<button type="button" class="mkvfit-pill" onclick="MKVFIT.pFuel(\'' + esc(f) + '\')">' + f + '</button>';
      }).join('');
      openStepPicker('engine');
      g('mkvfit-step-engine').style.display = 'flex';
    },

    pFuel: function(f) {
      sel.fuel = f;
      g('mkvfit-pills-engine').querySelectorAll('.mkvfit-pill').forEach(function(p) { p.classList.toggle('active', p.textContent === f); });
      if (g('mkvfit-step-engine').style.display !== 'none') collapseStep('engine', f);
      g('mkvfit-confirm-wrap').style.display = 'block';
      onVehicleChange();
      // P8 AUTO-CONFIRM : if all fields filled, trigger press animation + confirm
      tryAutoConfirm();
    },

    confirm: function() {
      if (!sel.make || !sel.model || !sel.year || !sel.sub || !sel.seats || !sel.drive || !sel.fuel) {
        alert(T.complete_all_info); return;
      }
      try { localStorage.setItem('matrikar_vehicle', JSON.stringify(sel)); } catch(e) {}
      updateCartProperties(sel);
      var displayName = sel.make + ' ' + sel.model + (sel.sub ? ' ' + sel.sub : '') + ' (' + sel.year + ')';
      var vehicleEl = g('mkvfit-vehicle-name'), detailsEl = g('mkvfit-vehicle-details');
      if (vehicleEl) vehicleEl.textContent = displayName;
      if (detailsEl) detailsEl.textContent = formatVehicleDetails(sel);
      g('mkvfit-selector').style.display = 'none';
      g('mkvfit-saved').style.display = 'flex';
      if (btnObserver) { btnObserver.disconnect(); btnObserver = null; }
      onVehicleChange();
      document.dispatchEvent(new CustomEvent('matrikar:vehicleSelected', { detail: sel }));
    },

    reopenStep: function(which) { openStepPicker(which); },
    resetToEmpty: resetToEmpty
  };

  // ─── Initialisation ───────────────────────────────────────────────────────
  function init() {
    ensureCartProperties();
    loadSavedVehicle();

    var changeBtn  = g('mkvfit-change-btn');
    var confirmBtn = g('mkvfit-confirm-btn');
    if (changeBtn)  changeBtn.onclick  = function() { resetToEmpty(); };
    if (confirmBtn) confirmBtn.onclick = function() { window.MKVFIT.confirm(); };

    ['make','model'].forEach(function(k) {
      var btn = g('mkvfit-btn-' + k);
      if (btn) btn.onclick = function() { togDrop(k); };
      var src = g('mkvfit-search-' + k);
      if (src) src.oninput = function() { filterList(k); };
    });

    document.addEventListener('click', function(e) {
      if (e.target && e.target.closest && e.target.closest('.mkvfit-drop')) return;
      var wrap = g('mkvfit-wrap');
      if (wrap && !wrap.contains(e.target)) closeDrops();
    });

    /* Focus recherche → relance le calage au-dessus du clavier (bottom sheet) */
    document.addEventListener('focusin', function(e) {
      if (e.target && e.target.classList && e.target.classList.contains('mkvfit-search')) {
        setTimeout(syncSheetToViewport, 60); setTimeout(syncSheetToViewport, 300);
      }
    });

    document.addEventListener('variant:changed', reapplyButtonState);
    document.addEventListener('change', function(e) {
      if (
        e.target.matches('[data-option-position]') ||
        e.target.matches('.variant-set-card input[type="radio"]') ||
        e.target.matches('[name="id"]')
      ) {
        reapplyButtonState();
      }
    });

    attachButtonObserver();
    waitForDB(function() { if (DB && DB.length > 0) initMakes(); });

    // PERF : matrikar-data.js est désormais chargé en lazy (1re interaction). Ce hook peuple les
    // marques dès que la DB arrive, même si waitForDB a déjà expiré (timeout 7 s) → sélecteur fiable.
    document.addEventListener('matrikar-data:ready', function() {
      if (!DB && typeof window.MATRIKAR_DB !== 'undefined' && window.MATRIKAR_DB) {
        buildDB();
        if (DB && DB.length > 0) initMakes();
      }
    });
  }

  // ─── Garantie inputs (résiliente au re-render AJAX) ───────────────────────
  // FIX intermittent : un swap de swatch couleur re-render la section produit
  // (mkv5-pdp.js: root.innerHTML = fresh) → le form neuf n'a plus les hidden
  // inputs properties[…], alors que les boutons restent cliquables → commande
  // sans véhicule. guaranteeProps() (re)crée les inputs s'ils manquent et les
  // (re)peuple depuis localStorage. IDEMPOTENT : ensureCartProperties() n'est
  // rappelé QUE si les inputs sont absents → ne wipe jamais une valeur peuplée.
  function guaranteeProps() {
    try {
      var form = getProductForm();
      if (!form) return;
      if (!form.querySelector('[data-mkvfit="vehicle"]')) ensureCartProperties();
      var saved = null;
      try { saved = JSON.parse(localStorage.getItem('matrikar_vehicle') || 'null'); } catch (e) {}
      if (saved && saved.make && saved.year && saved.model) updateCartProperties(saved);
    } catch (e) {
      try { console.error('[mkvfit] guaranteeProps failed', e); } catch (_) {}
    }
  }

  // COEUR DU FIX : MutationObserver sur .shopify-section--main-product. Le swap
  // fait root.innerHTML = fresh (root = ce wrapper) → mutation childList captée
  // → ré-injection. Débouncé (80 ms) + no-op si les inputs sont déjà présents.
  function watchProductForm() {
    try {
      var host = document.querySelector('.shopify-section--main-product') || document.body;
      var t = null;
      var mo = new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(guaranteeProps, 80);
      });
      mo.observe(host, { childList: true, subtree: true });
    } catch (e) {}
  }

  // init() isolé pour que la garantie tourne même si init throw (dépendances DOM/DB).
  function safeInit() {
    try { init(); }
    catch (e) { try { console.error('[mkvfit] init failed — fallback applied', e); } catch (_) {} }
    guaranteeProps();
    watchProductForm();
  }

  // Re-garantir à chaque confirmation (couvre aussi les clients venus d'accueil/
  // collection/LP, dont le véhicule transite par localStorage → matrikar:vehicleSelected).
  document.addEventListener('matrikar:vehicleSelected', function () { setTimeout(guaranteeProps, 0); });

  // Renfort déterministe : le swap dispatche 'variant:changed' juste après le re-render
  // (mkv5-pdp.js) → ré-injection immédiate, en complément du MutationObserver.
  document.addEventListener('variant:changed', function () { setTimeout(guaranteeProps, 0); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeInit);
  } else {
    safeInit();
  }
})();
